import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;
const enabled = process.env.REACT_APP_SENTRY_ENABLED === "true";

/**
 * Initialize Sentry for the admin portal. Call once, before React renders
 * (see index.tsx). No-op unless REACT_APP_SENTRY_ENABLED is "true" and a DSN is
 * set, so local runs without a DSN are unaffected.
 *
 * REACT_APP_* values are inlined at build time by Create React App, so the DSN
 * must be present when `yarn build` runs in CI, not at container runtime.
 */
export const initSentry = (): void => {
  if (!enabled || !dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? "local",
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: Number(
      process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? "0",
    ),
    integrations: [Sentry.browserTracingIntegration()],
    // Keep PII/PHI out of events for HIPAA. Sentry defaults this to false; set
    // explicitly so it is not silently changed.
    sendDefaultPii: false,
  });
};
